import { Alert, Box, CircularProgress, Paper, Typography } from "@mui/material"
import { MetaDrivenTable, PaginationControls, StatusChip } from "../../../shared/components"
import { useCommercialData } from "../../commercialsDashboard/hooks/useCommercialData";
import { formatCurrency } from "../../../shared/utils";

export const CommitmentsList = () => {

    const { data: commercialData, isLoading: isCommercialDataLoading, isError: isCommercialDataError, error: commercialDataError, pagination, changePage, changeRowsPerPage } = useCommercialData('commitment');

    const headers = [
        { "alias_name": "project", "label": "Project", "display_order": 1, is_show: true },
        { "alias_name": "supplier", "label": "Supplier", "display_order": 2, is_show: true },
        { "alias_name": "phase", "label": "Phase", "display_order": 3, is_show: true },
        { "alias_name": "budget", "label": "Budget", "display_order": 4, is_show: true },
        { "alias_name": "committed", "label": "Committed", "display_order": 5, is_show: true },
        { "alias_name": "commitment_percent", "label": "Commitment %", "display_order": 6, is_show: true },
        { "alias_name": "accruals", "label": "Accruals", "display_order": 7, is_show: true },
        { "alias_name": "headroom", "label": "Headroom", "display_order": 8, is_show: true },
    ];

    const metrics = {
        project: {
            type: 'component',
            element: ((data: { project: string, project_reference: string }) => (
                <>
                    <Typography variant="body2" color="text.primary">{data.project}</Typography>
                    <Typography variant="caption" color="text.secondary">{data.project_reference}</Typography>
                </>
            ))
        },
        budget: {
            type: 'component',
            element: ((data: { budget: number }) => (
                <>{formatCurrency(data.budget)}</>
            ))
        },
        accruals: {
            type: 'component',
            element: ((data: { accruals: number }) => (
                <>{formatCurrency(data.accruals)}</>
            ))
        },
        committed: {
            type: 'component',
            element: ((data: { committed: string }) => (
                <Typography>{formatCurrency(Number(data.committed))}</Typography>
            ))
        },
        headroom: {
            type: 'component',
            element: ((data: { headroom: string }) => (
                <Typography>{formatCurrency(Number(data.headroom))}</Typography>
            ))
        },
        commitment_percent: {
            type: 'component',
            element: ((data: { commitment_percent: string }) => (
                <Typography>{data.commitment_percent}%</Typography>
            ))
        }
    };

    if (isCommercialDataLoading) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
                my={5}
            >
                <CircularProgress />
            </Box>
        )
    };

    if (isCommercialDataError) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
            >
                <Alert
                    severity="warning"
                    sx={{
                        width: "auto",
                        justifyContent: "center",
                        textAlign: "center",
                    }}
                >
                    {commercialDataError?.message || "Something went wrong!"}
                </Alert>
            </Box>
        );
    }

    return (
        <Paper variant="outlined" sx={{ m: 2, py: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ px: 2 }}>Project Commitment Detail</Typography>
            <MetaDrivenTable headers={headers} data={commercialData} dataMetrics={metrics} sortDisabled />
            <PaginationControls total={pagination.total} rowsPerPage={pagination.limit} currentPage={pagination.page} handlePageChange={changePage} handleRowsPerPage={changeRowsPerPage} />
        </Paper>
    )
}